import { Col, Row } from "react-bootstrap";
import './WGYCIcon.css';

export default function WGYCIcon() {

    return (
        <Row>
            <Col>
                <div className="cardStyle d-flex align-items-center justify-content-center">
                    <Row>
                        <Col className="d-flex align-items-center justify-content-center">
                            <span className="textStyle"> 五癸运财-每日秘字水局 </span>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    )
}